/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance } from 'axios';
import { refreshTokenInterceptor } from './refresh-token';
import { store } from '../infra/store';

const localStorage = window.localStorage;

const localStorageData = localStorage.getItem('persist:root')
  ? JSON.parse(localStorage.getItem('persist:root') ?? '')
  : null;

const companyId =
  localStorageData && localStorageData?.authSlice
    ? JSON.parse(localStorageData?.authSlice)?.company_id
    : null;

const isViewAsSuperAdmin =
  localStorageData && localStorageData?.viewAsSuperAdminSlice
    ? JSON.parse(localStorageData?.viewAsSuperAdminSlice)?.isViewAsSuperAdmin
    : false;

export default class Core {
  private static instance: Core;

  public static getInstance(): Core {
    if (!Core.instance) {
      Core.instance = new Core();
    }

    return Core.instance;
  }
  public api() {
    const URL = process.env.REACT_APP_API_URL;

    const instance = axios.create({
      baseURL: URL,
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'X-Company-Id': companyId,
        'X-Platform': 'employee',
        'X-View-As-Super-Admin': isViewAsSuperAdmin,
      },
      withCredentials: true,
    });

    this.setRefreshToken(instance);

    this.setCompanyId(instance);

    return instance;
  }

  public pmsapi(companyID: any) {
    const URL = process.env.REACT_APP_PMS_URL;
    const instance = axios.create({
      baseURL: URL,
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'X-Company-Id': companyId,
        'X-Platform': 'employee',
        'X-View-As-Super-Admin': isViewAsSuperAdmin,
      },
      withCredentials: true,
    });

    this.setRefreshToken(instance);

    this.setCompanyId(instance);

    return instance;
  }

  public apiforImageUp() {
    const URL = process.env.REACT_APP_API_URL;

    const instance = axios.create({
      baseURL: URL,
      timeout: 60000,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'X-Company-Id': companyId,
        'X-Platform': 'employee',
        'X-View-As-Super-Admin': isViewAsSuperAdmin,
      },
      withCredentials: true,
    });

    this.setCompanyId(instance);

    return instance;
  }

  public multipartFormData() {
    const URL = process.env.REACT_APP_API_URL;

    const instance = axios.create({
      baseURL: URL,
      timeout: 60000,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'X-Company-Id': companyId,
        'X-Platform': 'employee',
        'X-View-As-Super-Admin': isViewAsSuperAdmin,
      },
      withCredentials: true,
    });

    this.setRefreshToken(instance);

    this.setCompanyId(instance);

    return instance;
  }

  private setRefreshToken(instance: AxiosInstance) {
    instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response.status !== 401) {
          throw {
            error: error?.response?.data,
          };
        }
        return await refreshTokenInterceptor(error, instance);
      },
    );
  }

  private setCompanyId(instance: AxiosInstance) {
    instance.interceptors.request.use(
      (config) => {
        config.headers['X-Company-Id'] = (store.getState() as any)?.authSlice
          ?.company_id;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  }
}

export const API_V1 = 'v1';
export const API_V2 = 'v2';
